<template>
  <main class="privacy-page">
    <section class="privacy-hero">
      <span class="eyebrow">PRIVACY POLICY</span>
      <h1>隐私政策</h1>
      <p>我们重视你的个人信息和实验数据安全。本政策说明 azlinux.com 运维练兵场如何收集、使用、存储和保护相关信息。</p>
      <div class="meta"><span>当前版本：v2.0</span><span>更新日期：2026-08-02</span><span>生效日期：2026-08-02</span></div>
    </section>

    <div class="privacy-layout">
      <aside class="privacy-nav">
        <strong>内容导航</strong>
        <a v-for="item in sections" :key="item.id" :href="`#${item.id}`">{{ item.label }}</a>
      </aside>

      <article class="privacy-content">
        <section id="scope">
          <h2>一、适用范围</h2>
          <p>本政策适用于 azlinux.com 运维练兵场提供的账户、云实验环境、场景部署、积分充值、文件传输和技术支持等服务。</p>
          <div class="notice">请勿在练习实例、工单或上传文件中保存真实生产密码、SSH 私钥、支付密码、商业秘密等敏感信息。</div>
        </section>

        <section id="collection">
          <h2>二、我们收集的信息</h2>
          <div class="data-list">
            <div><strong>账户信息</strong><span>注册邮箱、昵称、账户状态以及你主动设置的实验账户信息。</span></div>
            <div><strong>服务与计费信息</strong><span>实例规格、镜像、使用时长、积分余额、充值订单和消费流水。</span></div>
            <div><strong>运行与安全日志</strong><span>登录时间、IP 地址、浏览器信息、接口请求、任务状态和异常日志，用于保障服务和排查故障。</span></div>
            <div><strong>支持信息</strong><span>你通过工单或邮件提供的问题描述、任务 ID、截图及联系方式。</span></div>
            <div><strong>文件传输信息</strong><span>使用网页上传或下载功能时，文件会经平台传输至你选择的实验实例；平台仅为完成该操作进行必要处理。</span></div>
          </div>
          <p>我们不会要求你提供身份证号码、银行卡密码或支付密码。请不要主动提交与使用服务无关的敏感个人信息。</p>
        </section>

        <section id="usage">
          <h2>三、信息使用目的</h2>
          <ul>
            <li>创建和维护账户，完成登录认证与安全校验；</li>
            <li>创建、管理和释放云实验资源，执行场景部署任务；</li>
            <li>计算积分消耗、处理充值确认并展示账户流水；</li>
            <li>处理工单、故障排查、风险控制和服务改进；</li>
            <li>在必要时发送账户安全、服务变更或交易相关通知；</li>
            <li>履行法律法规规定的安全、审计和合规义务。</li>
          </ul>
          <p>我们不会出售你的个人信息，也不会将其用于与本平台服务无关的个性化广告。</p>
        </section>

        <section id="sharing">
          <h2>四、委托处理与信息共享</h2>
          <p>为了提供云资源、存储、网络、邮件及支付相关能力，我们可能使用阿里云等基础设施或第三方服务。我们仅提供完成服务所必需的信息，并要求相关服务方按照约定和法律要求保护数据。</p>
          <p>除获得你的授权、履行合同所必需或法律法规另有规定外，我们不会向其他第三方公开或提供你的个人信息。</p>
        </section>

        <section id="storage">
          <h2>五、信息存储与保留</h2>
          <p>信息主要存储在中华人民共和国境内。我们会在实现本政策所述目的所需的最短期限内保存数据；法律法规对交易、安全日志等保留期限另有要求的，从其规定。</p>
          <p>实验实例属于临时资源，释放后实例内数据可能随之删除且无法恢复。请在释放前自行下载需要保留的练习文件。</p>
        </section>

        <section id="security">
          <h2>六、信息安全</h2>
          <p>我们采用传输加密、访问控制、权限隔离、身份认证、日志审计和备份等措施降低信息被未授权访问、篡改、泄露或丢失的风险。</p>
          <p>互联网服务无法保证绝对安全。如发生可能影响你权益的安全事件，我们将依法采取补救措施，并通过站内通知、邮件或公告告知相关情况。</p>
        </section>

        <section id="rights">
          <h2>七、你的权利</h2>
          <p>你可以通过账户中心查看或修改部分资料，并可联系我们申请查询、更正、删除个人信息、注销账户或撤回相关授权。为保障账户安全，我们可能需要先核验申请人身份。</p>
          <p>合理请求通常会在核验身份后尽快处理；涉及交易记录、安全审计或法律规定必须保留的信息，可能无法立即删除。</p>
        </section>

        <section id="cookies">
          <h2>八、Cookie 与本地存储</h2>
          <p>我们使用必要的 Cookie 或浏览器本地存储维持登录状态、保存页面偏好并保障账户安全。禁用必要 Cookie 可能导致登录及部分功能无法使用。</p>
        </section>

        <section id="updates">
          <h2>九、政策更新</h2>
          <p>当服务范围、处理方式或法律要求发生变化时，我们可能更新本政策。重大变更会通过页面提示、站内公告或邮件等适当方式告知。</p>
        </section>

        <section id="contact" class="contact-section">
          <div><h2>十、联系我们</h2><p>如对本政策、个人信息处理或账户注销有疑问，请通过注册邮箱联系我们，并简要说明请求内容。</p></div>
          <a href="mailto:admin@azlinux.com?subject=azlinux.com%20隐私事项咨询">admin@azlinux.com</a>
        </section>
      </article>
    </div>
  </main>
</template>

<script>
export default {
  name: "UserPrivacy",
  data() {
    return {
      sections: [
        { id: "scope", label: "适用范围" }, { id: "collection", label: "信息收集" },
        { id: "usage", label: "使用目的" }, { id: "sharing", label: "信息共享" },
        { id: "storage", label: "存储与保留" }, { id: "security", label: "信息安全" },
        { id: "rights", label: "用户权利" }, { id: "cookies", label: "Cookie" },
        { id: "updates", label: "政策更新" }, { id: "contact", label: "联系我们" },
      ],
    };
  },
};
</script>

<style scoped>
.privacy-page { min-height: calc(100vh - 70px); padding: 46px 24px 80px; background: #f4f7fb; color: #213449; text-align: left; scroll-behavior: smooth; }
.privacy-hero, .privacy-layout { width: min(1080px, 100%); margin-inline: auto; }.privacy-hero { padding: 22px 0 34px; border-bottom: 1px solid #dfe7ef; }.eyebrow { color: #2878d0; font-size: 12px; font-weight: 800; letter-spacing: .12em; }.privacy-hero h1 { margin: 8px 0 12px; font-size: clamp(34px, 5vw, 48px); letter-spacing: -.04em; }.privacy-hero p { max-width: 760px; margin: 0; color: #637387; font-size: 16px; line-height: 1.8; }.meta { display: flex; flex-wrap: wrap; gap: 18px; margin-top: 20px; color: #8290a0; font-size: 13px; }
.privacy-layout { display: grid; grid-template-columns: 190px minmax(0, 1fr); gap: 42px; padding-top: 32px; }.privacy-nav { position: sticky; top: 90px; align-self: start; display: grid; gap: 4px; padding: 18px; border: 1px solid #e0e8f0; border-radius: 12px; background: #fff; }.privacy-nav strong { margin-bottom: 8px; color: #31475e; }.privacy-nav a { padding: 7px 9px; border-radius: 7px; color: #708095; font-size: 13px; text-decoration: none; }.privacy-nav a:hover { background: #edf5fd; color: #2878d0; }
.privacy-content { padding: 8px 34px 34px; border: 1px solid #e0e8f0; border-radius: 16px; background: #fff; box-shadow: 0 8px 28px rgba(34,64,98,.05); }.privacy-content section { padding-top: 28px; scroll-margin-top: 86px; }.privacy-content h2 { margin: 0 0 14px; color: #233b54; font-size: 20px; }.privacy-content p, .privacy-content li { color: #5f7083; font-size: 14px; line-height: 1.9; }.privacy-content ul { padding-left: 20px; }.notice { margin: 18px 0 0; padding: 14px 16px; border-left: 3px solid #e6a23c; border-radius: 6px; background: #fff8eb; color: #765721; font-size: 14px; line-height: 1.7; }.data-list { display: grid; gap: 10px; margin: 16px 0; }.data-list div { display: grid; grid-template-columns: 130px 1fr; gap: 15px; padding: 13px 15px; border: 1px solid #e7edf3; border-radius: 9px; background: #f9fbfd; }.data-list strong { color: #35516d; }.data-list span { color: #65768a; font-size: 14px; line-height: 1.7; }
.contact-section { display: grid; grid-template-columns: 1fr auto; gap: 28px; align-items: center; margin-top: 28px; padding: 24px !important; border: 1px solid #d5e5f5; border-radius: 12px; background: #f2f8ff; }.contact-section h2 { margin-bottom: 7px; }.contact-section p { margin: 0; }.contact-section a { padding: 11px 16px; border-radius: 8px; background: #2878d0; color: #fff; font-weight: 700; text-decoration: none; }
@media (max-width: 760px) { .privacy-page { padding: 26px 14px 50px; }.privacy-layout { grid-template-columns: 1fr; gap: 16px; }.privacy-nav { position: static; grid-template-columns: repeat(2, 1fr); }.privacy-nav strong { grid-column: 1 / -1; }.privacy-content { padding: 4px 20px 24px; }.data-list div, .contact-section { grid-template-columns: 1fr; }.contact-section a { text-align: center; } }
</style>
